import React from 'react';
import type { SearchAttackPathNode } from './types';
import { AttackPathNodeMeta } from './AttackPathNodeMeta';

/** Tooltip for attack path nodes in search: full meta (Header, Context, Details, ActionInstruction) with search-specific CTA. */
export const SearchAttackPathNodeTooltip: React.FC<{
  item: SearchAttackPathNode & {
    id?: string;
    label?: string;
    [key: string]: unknown;
  };
  closeTooltip: () => void;
}> = ({ item, closeTooltip }) => {
  return <AttackPathNodeMeta node={item} closeTooltip={closeTooltip} />;
};
